import toastr from "toastr";

toastr.options.escapeHtml = true;
toastr.options.extendedTimeOut = 1000;
toastr.options.timeOut = 2000;
toastr.options.fadeOut = 250;
toastr.options.fadeIn = 250;

export default toastr;